"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsUpgrade = void 0;
const utilsSQLite_1 = require("./utilsSQLite");
class UtilsUpgrade {
    constructor() {
        this.sqliteUtil = new utilsSQLite_1.UtilsSQLite();
    }
    /**
     * OnUpgrade
     * @param mDB
     * @param vUpgDict
     * @param dbName
     * @param curVersion
     * @param targetVersion
     */
    async onUpgrade(mDB, vUpgDict, curVersion, targetVersion) {
        let changes;
        const sortedKeys = new Int32Array(Object.keys(vUpgDict).map(item => parseInt(item))).sort();
        for (const versionKey of sortedKeys) {
            if (versionKey > curVersion && versionKey <= targetVersion) {
                const statements = vUpgDict[versionKey].statements;
                if (statements.length === 0) {
                    return Promise.reject('onUpgrade: statements not given');
                }
                try {
                    // set Foreign Keys Off
                    this.sqliteUtil.setForeignKeyConstraintsEnabled(mDB.database, false);
                    const initChanges = this.sqliteUtil.dbChanges(mDB.database);
                    await this.executeStatementsProcess(mDB, statements);
                    this.sqliteUtil.setVersion(mDB.database, versionKey);
                    // set Foreign Keys On
                    this.sqliteUtil.setForeignKeyConstraintsEnabled(mDB.database, true);
                    changes =
                        (await this.sqliteUtil.dbChanges(mDB.database)) - initChanges;
                }
                catch (err) {
                    return Promise.reject(`onUpgrade: ${err}`);
                }
            }
        }
        return Promise.resolve(changes);
    }
    /**
     * ExecuteStatementProcess
     * @param mDB
     * @param statements
     */
    async executeStatementsProcess(mDB, statements) {
        try {
            this.sqliteUtil.beginTransaction(mDB.database, true);
            mDB.setIsTransActive(true);
            for (const statement of statements) {
                this.sqliteUtil.execute(mDB.database, statement, false, true);
            }
            this.sqliteUtil.commitTransaction(mDB.database, true);
            mDB.setIsTransActive(false);
            return Promise.resolve();
        }
        catch (err) {
            this.sqliteUtil.rollbackTransaction(mDB.database, true);
            mDB.setIsTransActive(false);
            return Promise.reject(`ExecuteStatementProcess: ${err}`);
        }
    }
}
exports.UtilsUpgrade = UtilsUpgrade;
//# sourceMappingURL=utilsUpgrade.js.map